export default __webpack_public_path__ + "static/media/dot_active_fulfilment.c21f8356.svg";